import type { VocabType } from '@/mocks/vocabularyQuestions';
import type { ReadingType } from '@/mocks/readingQuestions';

export const vocabTypeColorMap: Record<VocabType, { badge: string; bar: string }> = {
  daily: { badge: 'bg-primary-100 text-primary-700', bar: 'bg-primary-500' },
  current: { badge: 'bg-accent-100 text-accent-700', bar: 'bg-accent-500' },
  economy: { badge: 'bg-secondary-100 text-secondary-700', bar: 'bg-secondary-500' },
  science: { badge: 'bg-primary-50 text-primary-700', bar: 'bg-primary-400' },
  art: { badge: 'bg-accent-50 text-accent-700', bar: 'bg-accent-400' },
  politics: { badge: 'bg-secondary-50 text-secondary-700', bar: 'bg-secondary-400' },
  culture: { badge: 'bg-primary-100 text-primary-700', bar: 'bg-primary-600' },
};

export const readingTypeColorMap: Record<ReadingType, { badge: string; bar: string }> = {
  daily: { badge: 'bg-primary-100 text-primary-700', bar: 'bg-primary-500' },
  current: { badge: 'bg-accent-100 text-accent-700', bar: 'bg-accent-500' },
  economy: { badge: 'bg-secondary-100 text-secondary-700', bar: 'bg-secondary-500' },
  science: { badge: 'bg-primary-50 text-primary-700', bar: 'bg-primary-400' },
  culture: { badge: 'bg-accent-50 text-accent-700', bar: 'bg-accent-400' },
  humanities: { badge: 'bg-secondary-50 text-secondary-700', bar: 'bg-secondary-400' },
};